import { ElSlider, type SliderProps } from 'element-plus'
import type { FunctionalComponent } from 'vue'
import './HocElSlider.scss'

export type Arrayable<T> = T | T[]

type HocElSliderProps = Partial<SliderProps> & {
  onChange?: ((value: Arrayable<number>) => any) | undefined
  onInput?: ((value: Arrayable<number>) => any) | undefined
  sliderRef?: Ref<InstanceType<typeof ElSlider>>
}

export const HocElSlider: FunctionalComponent<HocElSliderProps> = (_props, { attrs }) => {
  return (
    <div class="hoc-el-slider">
      <div class="slider">
        <ElSlider {...attrs} />
      </div>
    </div>
  )
}
HocElSlider.inheritAttrs = false
